import React from 'react';
import './styles/ScheduleSlotPopup.css';

const ScheduleSlotPopup = ({ slotList, selectedSessions, classType, type, onToggle, onClose, activeStudentId }) => {
    const getKey = (t, d, time) => `${t}_${d}_${time}`;
    const selectedMap = selectedSessions.reduce((map, s) => {
        map[getKey(s.teacher_id, s.day_of_week, s.time_start)] = true;
        return map;
    }, {});

    const EC_DAYS = {
        GLOW: ['SENIN', 'RABU'],
        SHINE: ['SELASA', 'KAMIS'],
    };
    const DAYS = classType === 'ENGLISH_CLUB' && type ? EC_DAYS[type] || []: ['SENIN', 'SELASA', 'RABU', 'KAMIS', 'JUMAT', 'SABTU'];
    const TIMES = ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'];
    const maxSlot = classType === 'ENGLISH_CLUB' ? 10 : 4;

    const addMinutes = (time, mins) => {
        const [h, m] = time.split(':').map(Number);
        const date = new Date(0, 0, 0, h, m + mins);
        return date.toTimeString().substring(0, 5);
    };
      

    return (
        <div className="popup slot-popup">
            <h3>Pilih Slot Jadwal</h3>
            <div className="slot-session">
                <table className="slot-table">
                    <thead>
                        <tr>
                        <th rowSpan={2}>Time</th>
                        <th rowSpan={2}>Teacher</th>
                        {DAYS.map(day => <th key={day}>{day}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {TIMES.map(time =>
                        slotList.map((guru, gIdx) => (
                            <tr key={`${guru.teacher_id}_${time}`} className={gIdx === 0 ? 'slot-time-separator' : ''}>
                            {gIdx === 0 && (
                                <td rowSpan={slotList.length}><b> {time} - {addMinutes(time, 45)}</b></td>
                            )}
                            <td>{guru.teacher_name}</td>
                            {DAYS.map(day => {
                                let typeClass = 'FREE';
                                const slot = guru.slots?.[day]?.[time] || { students: [] };
                                const siswaList = slot.students || [];
                                const key = getKey(guru.teacher_id, day, time);
                                const isSelected = selectedMap[key];
                                const isAlreadyInSlot = slot.students.some(s => s.student_id === activeStudentId);
                                return (
                                <td key={guru.teacher_id + day + time}>
                                    <div className="slot-cell-grid">
                                    {[...Array(maxSlot)].map((_, i) => {
                                        
                                        const siswa = siswaList[i];
                                        const isNextSlot = i === siswaList.length;

                                        if (siswa) {
                                            typeClass = siswa.session_type;
                                        }
                                        const available = (classType === typeClass || typeClass === 'FREE');
                                        const canPick = !siswa && !isAlreadyInSlot && available;
                                        
                                        if (siswa) return <div key={i} className={`slot-siswa ${siswa.session_type === 'ENGLISH_CLUB' ? 'slot-ec' : ''}`}>{siswa.student_name}</div>;
                                        
                                        if (canPick && isNextSlot) {
                                        return (
                                            <div key={i} className="slot-pick">
                                            <button
                                                className={isSelected ? 'selected' : ''}
                                                onClick={() => onToggle(guru.teacher_id, day, time)}
                                            >*</button>
                                            </div>
                                        );
                                        }
                                        return <div key={i} className="slot-empty" />;
                                    })}
                                    </div>
                                </td>
                                );
                            })}
                            </tr>
                        ))
                        )}
                    </tbody>
                </table>
            </div>
            <div className="search-container">
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
};

export default ScheduleSlotPopup;
